export const MERCHANT_PRODUCT_CREATE_REQUEST = "MERCHANT_PRODUCT_CREATE_REQUEST";
export const MERCHANT_PRODUCT_CREATE_SUCCESS = "MERCHANT_PRODUCT_CREATE_SUCCESS";
export const MERCHANT_PRODUCT_CREATE_FAIL = "MERCHANT_PRODUCT_CREATE_FAIL";
export const MERCHANT_PRODUCT_CREATE_RESET = "MERCHANT_PRODUCT_CREATE_RESET";

export const MERCHANT_PRODUCT_LIST_REQUEST = "MERCHANT_PRODUCT_LIST_REQUEST";
export const MERCHANT_PRODUCT_LIST_SUCCESS = "MERCHANT_PRODUCT_LIST_SUCCESS";
export const MERCHANT_PRODUCT_LIST_FAIL = "MERCHANT_PRODUCT_LIST_FAIL";
export const MERCHANT_PRODUCT_LIST_RESET = "MERCHANT_PRODUCT_LIST_RESET";

export const MERCHANT_PRODUCT_DELETE_REQUEST = "MERCHANT_PRODUCT_DELETE_REQUEST";
export const MERCHANT_PRODUCT_DELETE_SUCCESS = "MERCHANT_PRODUCT_DELETE_SUCCESS";
export const MERCHANT_PRODUCT_DELETE_FAIL = "MERCHANT_PRODUCT_DELETE_FAIL";

export const MERCHANT_PRODUCT_DETAILS_REQUEST = "MERCHANT_PRODUCT_DETAILS_REQUEST";
export const MERCHANT_PRODUCT_DETAILS_SUCCESS = "MERCHANT_PRODUCT_DETAILS_SUCCESS";
export const MERCHANT_PRODUCT_DETAILS_FAIL = "MERCHANT_PRODUCT_DETAILS_FAIL";
export const MERCHANT_PRODUCT_DETAILS_RESET = "MERCHANT_PRODUCT_DETAILS_RESET";

export const MERCHANT_PRODUCT_UPDATE_REQUEST = "MERCHANT_PRODUCT_UPDATE_REQUEST";
export const MERCHANT_PRODUCT_UPDATE_SUCCESS = "MERCHANT_PRODUCT_UPDATE_SUCCESS";
export const MERCHANT_PRODUCT_UPDATE_FAIL = "MERCHANT_PRODUCT_UPDATE_FAIL";
export const MERCHANT_PRODUCT_UPDATE_RESET = "MERCHANT_PRODUCT_UPDATE_RESET";

export const MERCHANT_PRODUCT_STOCK_CHANGE_REQUEST = "MERCHANT_PRODUCT_STOCK_CHANGE_REQUEST";
export const MERCHANT_PRODUCT_STOCK_CHANGE_SUCCESS = "MERCHANT_PRODUCT_STOCK_CHANGE_SUCCESS";
export const MERCHANT_PRODUCT_STOCK_CHANGE_FAIL = "MERCHANT_PRODUCT_STOCK_CHANGE_FAIL";

export const MERCHANT_PRODUCT_BULK_APPLY_REQUEST = "MERCHANT_PRODUCT_BULK_APPLY_REQUEST";
export const MERCHANT_PRODUCT_BULK_APPLY_SUCCESS = "MERCHANT_PRODUCT_BULK_APPLY_SUCCESS";
export const MERCHANT_PRODUCT_BULK_APPLY_FAIL = "MERCHANT_PRODUCT_BULK_APPLY_FAIL";
export const MERCHANT_PRODUCT_BULK_APPLY_RESET = "MERCHANT_PRODUCT_BULK_APPLY_RESET";

export const SIZES_CREATE_REQUEST = "SIZES_CREATE_REQUEST";
export const SIZES_CREATE_SUCCESS = "SIZES_CREATE_SUCCESS";
export const SIZES_CREATE_FAIL = "SIZES_CREATE_FAIL";
export const SIZES_CREATE_RESET = "SIZES_CREATE_RESET";

export const SIZES_DELETE_REQUEST = "SIZES_DELETE_REQUEST";
export const SIZES_DELETE_SUCCESS = "SIZES_DELETE_SUCCESS";
export const SIZES_DELETE_FAIL = "SIZES_DELETE_FAIL";

export const SIZES_UPDATE_REQUEST = "SIZES_UPDATE_REQUEST";
export const SIZES_UPDATE_SUCCESS = "SIZES_UPDATE_SUCCESS";
export const SIZES_UPDATE_FAIL = "SIZES_UPDATE_FAIL";
export const SIZES_UPDATE_RESET = "SIZES_UPDATE_RESET";

export const ADMIN_UNAPPROVED_LIST_REQUEST = "ADMIN_UNAPPROVED_LIST_REQUEST";
export const ADMIN_UNAPPROVED_LIST_SUCCESS = "ADMIN_UNAPPROVED_LIST_SUCCESS";
export const ADMIN_UNAPPROVED_LIST_FAIL = "ADMIN_UNAPPROVED_LIST_FAIL";

export const ADMIN_APPROVE_PRODUCT_REQUEST = "ADMIN_APPROVE_PRODUCT_REQUEST";
export const ADMIN_APPROVE_PRODUCT_SUCCESS = "ADMIN_APPROVE_PRODUCT_SUCCESS";
export const ADMIN_APPROVE_PRODUCT_FAIL = "ADMIN_APPROVE_PRODUCT_FAIL";

export const STOCK_CHECK_REQUEST = "STOCK_CHECK_REQUEST";
export const STOCK_CHECK_SUCCESS = "STOCK_CHECK_SUCCESS";
export const STOCK_CHECK_FAIL = "STOCK_CHECK_FAIL";

export const SEARCH_PRODUCT_REQUEST = "SEARCH_PRODUCT_REQUEST";
export const SEARCH_PRODUCT_SUCCESS = "SEARCH_PRODUCT_SUCCESS";
export const SEARCH_PRODUCT_FAIL = "SEARCH_PRODUCT_FAIL";
export const SEARCH_PRODUCT_RESET = "SEARCH_PRODUCT_RESET";

export const MERCHANT_PRODUCT_VALIDATE_REQUEST = "MERCHANT_PRODUCT_VALIDATE_REQUEST";
export const MERCHANT_PRODUCT_VALIDATE_SUCCESS = "MERCHANT_PRODUCT_VALIDATE_SUCCESS";
export const MERCHANT_PRODUCT_VALIDATE_FAIL = "MERCHANT_PRODUCT_VALIDATE_FAIL";

export const ADMIN_CUSTOM_PRODUCTSEXPORT_REQUEST = "ADMIN_CUSTOM_PRODUCTSEXPORT_REQUEST";
export const ADMIN_CUSTOM_PRODUCTSEXPORT_SUCCESS = "ADMIN_CUSTOM_PRODUCTSEXPORT_SUCCESS";
export const ADMIN_CUSTOM_PRODUCTSEXPORT_FAIL = "ADMIN_CUSTOM_PRODUCTSEXPORT_FAIL";
export const ADMIN_CUSTOM_PRODUCTSEXPORT_RESET = "ADMIN_CUSTOM_PRODUCTSEXPORT_RESET";

export const PRODUCT_CUSTOMER_REQUEST = "PRODUCT_CUSTOMER_REQUEST";
export const PRODUCT_CUSTOMER_SUCCESS = "PRODUCT_CUSTOMER_SUCCESS";
export const PRODUCT_CUSTOMER_FAIL = "PRODUCT_CUSTOMER_FAIL";
